import { useTeamMenuItems } from '../../TeamDashboard/components/TeamSubheader'
import GuildContext from 'app/frontend/base/config/context/guild'
import EntityMenu from 'app/frontend/base/components/EntityMenu'
import BannerImage from 'app/frontend/base/components/BannerImage'
import { Link } from 'react-router-dom'
import { useTheme } from '@/components/theme-provider'
import { useCustomDomain } from 'app/frontend/base/hooks/useCustomDomain'
import { useActionable } from 'app/frontend/base/hooks/useActionable'
import { usePageInfo } from 'app/frontend/base/config/queries'
import { cn } from '@/lib/utils'

const CustomDomainSidebar = () => {
  const { currentScheme } = useTheme()
  const { customDomain } = useCustomDomain()
  const {
    data: { user },
  } = usePageInfo()
  const { currentAction } = useActionable(user)

  if (!customDomain) return null

  const headerLogoPath =
    currentScheme === 'dark'
      ? customDomain?.darkModeHeaderLogoPath
      : customDomain?.lightModeHeaderLogoPath

  return (
    <div className={cn('flex gap-2 flex-col', currentAction ? 'pt-8' : '')}>
      <Link to='/' className='flex items-center gap-2 shrink-0'>
        {headerLogoPath ? (
          <img src={headerLogoPath} className='w-full px-2' />
        ) : (
          <BannerImage
            className='w-12 h-12 min-w-12 min-h-12'
            faction={customDomain.guild.faction}
            fileName={customDomain.guild.bannerFilename}
            size='custom'
          />
        )}

        {customDomain.headerShowName ? (
          <span className='text-xl font-bold text-accent-foreground'>
            {customDomain.guild.name}
          </span>
        ) : null}
      </Link>

      <div className='flex flex-col gap-0'>
        {customDomain.team ? (
          <GuildContext.Provider
            value={{
              guild: customDomain.guild,
              guildReference: customDomain.guild,
              currentTeam: customDomain.team,
              teamReference: customDomain.team,
            }}
          >
            <CustomDomainTeamSidebar />
          </GuildContext.Provider>
        ) : (
          <GuildContext.Provider
            value={{
              guild: customDomain.guild,
              guildReference: customDomain.guild,
            }}
          >
            <CustomDomainGuildSidebar />
          </GuildContext.Provider>
        )}
      </div>
    </div>
  )
}

const CustomDomainTeamSidebar = () => {
  const { menuItems } = useTeamMenuItems()
  if (!menuItems.length) return null

  return <EntityMenu menuItems={menuItems} placement='header' />
}

const CustomDomainGuildSidebar = () => {
  return <div>CustomDomainGuildSidebar</div>
}

export default CustomDomainSidebar
